import { useRef, useState, type ComponentType } from 'react';
import { Plus, type LucideProps } from 'lucide-react';
import { Dialog, DialogContent } from '@/shared/ui';
import { cn } from '@/shared/lib/cn';
import styles from './ComposerActionSheet.module.css';

export interface ComposerAction {
  key: string;
  label: string;
  Icon: ComponentType<LucideProps>;
  onSelect: () => void;
  pressed?: boolean;
}

export function ComposerActionSheet({
  actions,
  triggerClassName,
}: {
  actions: ComposerAction[];
  triggerClassName?: string;
}) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const anyPressed = actions.some((a) => a.pressed);

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className={cn(triggerClassName, anyPressed && styles.triggerPressed)}
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label="Добавить к сообщению"
      >
        <Plus size={20} aria-hidden />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          flush
          className={styles.sheet}
          aria-label="Добавить к сообщению"
          finalFocus={triggerRef}
        >
          <div className={styles.grid}>
            {actions.map(({ key, label, Icon, onSelect, pressed }) => (
              <button
                key={key}
                type="button"
                className={cn(styles.action, pressed && styles.actionPressed)}
                aria-pressed={pressed}
                onClick={() => {
                  setOpen(false);
                  onSelect();
                }}
              >
                <span className={styles.actionIcon}>
                  <Icon size={22} aria-hidden />
                </span>
                <span className={styles.actionLabel}>{label}</span>
              </button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
